import { Component } from 'react';
import { report } from 'hc-ravenjs-logger';
import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';

import { NULL_STATE_WARNINGS } from 'legacy/appstore/constants';

const errorBoundaryNullStateCard = (WrappedComponent, contentKey) => {
  return class ErrorBoundaryNullStateCard extends Component {
    state = { hasError: false };

    componentDidCatch(error, errorInfo) {
      this.setState({ hasError: true });
      report(error, {
        errorInfo,
        originalError: error
      });
    }

    render() {
      if (this.state.hasError) {
        const nullContent = NULL_STATE_WARNINGS[contentKey];
        if (nullContent) {
          const { title, message } = nullContent;
          return (
            <NullStateCard title={title} style={{ margin: '40px auto' }}>
              {message}
            </NullStateCard>
          );
        } else {
          return null;
        }
      }
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default errorBoundaryNullStateCard;
